import { render, staticRenderFns } from "./ChemUCI51LBA2_M3Q5a.vue?vue&type=template&id=5122d34f&"
import script from "./ChemUCI51LBA2_M3Q5a.vue?vue&type=script&lang=js&"
export * from "./ChemUCI51LBA2_M3Q5a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VSimpleTable,VTextField})
